<template>
  <section class="custom-wizard-wrapper">
    <div class="row">
      <div class="col-2">
        <img src="~@/assets/J_Logo_Black_Offset_256x256.png" alt="Welcome to Invoices AI" width="64" height="64" />
        <span class="custom-app-title">Invoices AI</span>
      </div>
      <div class="col"></div>
      <div class="col-2 custom-logo">
        <img
          class="custom-tagline"
          src="~@/assets/J_Logo_Black_Offset_256x256.png"
          width="32"
          height="32"
          alt="Easy Invoicing"
          @click="checkForTesting"
        />
        <a href="https://www.jingleenterprises.com/" target="_blank">
          <span class="custom-logo-title">Jingle Enterprises</span>
        </a>
        <span class="custom-testmode" v-show="testMode">Test Mode</span>
      </div>
    </div>
    <hr />
    <OnboardWizard :companyId="companyId" :saveIt="true" />
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { onboardStore } from '@/stores/onboard'
import OnboardWizard from '@/components/onboard/OnboardWizard.vue'
export default {
  name: 'OnboardView',
  components: {
    OnboardWizard
  },
  data() {
    return {
      companyId: null,
      testClickCount: 0
    }
  },
  mounted() {
    this.companyId = this.$route.params.id
    this.testClickCount = 0
    this.setTestMode(false)
  },
  computed: {
    ...mapState(onboardStore, ['testMode'])
  },
  methods: {
    ...mapActions(onboardStore, ['setTestMode']),
    checkForTesting() {
      this.testClickCount++
      if (this.testClickCount === 5) {
        this.setTestMode(!this.testMode)
        this.testClickCount = 0
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wizard-wrapper {
  padding: 15px;
}
.custom-title {
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-style: italic;
  margin-top: 10px;
  color: #37404f;
  float: right;
  span {
    font-size: 0.6em;
    top: -10px;
    position: relative;
  }
  cursor: pointer;
}
.custom-loading {
  width: 100%;
  margin-top: 15px;
  text-align: center;
}
.custom-tagline {
  cursor: pointer;
}
.custom-testmode {
  font-size: 0.8em;
  position: absolute;
  bottom: 2px;
  right: 45px;
  font-weight: 500;
  color: red;
}
.custom-logo {
  position: relative;
  text-align: right;
}
.custom-app-title {
  position: relative;
  font-style: italic;
  font-size: 1.2em;
  font-weight: 500;
  top: 10px;
  left: 10px;
}
.custom-logo-title {
  position: relative;
  font-size: 1em;
  font-weight: 500;
  top: 5px;
  left: 5px;
}
</style>
